<h1 mat-dialog-title>Limite de requisições atingido</h1>

<mat-dialog-content>
  <ng-container *ngIf="!isMakena; else makenaTemplate">
    <mat-dialog-content>
      <p>Esta empresa atingiu o limite de requisições do serviço <em>T5 Info</em>, que consulta informações de um veículo
        a partir da placa.</p>
      <p>Para mais informações, entre em contato com a Tecinco</p>
  
      <div class="contact">
        <p>
          <a href="https://www.tecinco.com.br/"
             target="_blank">
            <mat-icon class="contact-icon">location_city</mat-icon>
            {{ 'INFO.DEVELOPER_NAME' | translate }}
          </a>
        </p>
        <p>
          <a href="https://goo.gl/maps/kbEUFziJk8FgbAx87"
             target="_blank">
            <mat-icon class="contact-icon">location_on</mat-icon>
            {{ 'INFO.DEVELOPER_ADDRESS' | translate }}
          </a>
        </p>
        <!-- <p>
          <a [href]="'mailto:' + ('INFO.DEVELOPER_EMAIL' | translate)"
             target="_blank">
            <mat-icon class="contact-icon">mail</mat-icon>
            <span>{{ 'INFO.DEVELOPER_EMAIL' | translate }}</span>
          </a>
        </p> -->
      </div>
    </mat-dialog-content>
  </ng-container>
  
  <ng-template #makenaTemplate>
    <mat-dialog-content>
      <p>Esta empresa atingiu o limite de requisições do serviço de consulta de placas</p>
      <p>Para mais informações, entre em contato com o suporte.</p>
    </mat-dialog-content>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button
          color="primary"
          type="button"
          cdkFocusInitial
          (click)="close()">
    OK
  </button>
  <button mat-raised-button
          class="whatsapp-button"
          type="button"
          (click)="onClickWhatsApp()">
    <mat-icon>phone</mat-icon>
    <span>{{ 'ACTION.SHARED.SEND_MESSAGE_ON_WHATSAPP' | translate }}</span>
  </button>
</mat-dialog-actions>
